var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}}),_vm._v(" "),_c('cal-hover',{ref:"calHover",attrs:{"users":_vm.users,"renforts":_vm.renforts,"participantsCount":_vm.participantsCount,"userType":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }